import clsx from 'clsx';
import React from 'react';
import { classHasFontSize, classHasFontWeight } from '../../utils/css'

export type TitleProps = {
  as?: "div" | "p"
} & React.HTMLAttributes<HTMLParagraphElement>

/**
 * Figma defaults (defaults to `className="font-bold font-title text-title-md"`):
 * - CSS class `text-title-lg` => (40px) Large Title Bold
 * - CSS class `text-title-md` => (24px) Medium Title Bold
 * - CSS class `text-title-sm` => (18px) Small Title Bold
 * - CSS class `text-title-xs` => (14px) Large Title Bold
 * 
 * Usage:
 * ```tsx
 * <Title className="text-title-sm">...</Title>
 * ```
 * 
 * @link https://www.figma.com/file/90yJgaRuWbIDYh7QrSE3IY/Eternity-UI?node-id=319%3A3089
 */
function Title({
  className,
  children,
  as,
  ...rest
}: TitleProps) {

  if (as === "div") {
    return (
      <div
        className={clsx(
          className,
          !classHasFontSize(className) && "text-title-md",
          !classHasFontWeight(className) && "font-semibold",
          "font-title text",
        )}
        {...rest}
      >
        {children}
      </div>
    )
  }

  return (
    <p
      className={clsx(
        className,
        !classHasFontSize(className) && "text-title-md",
        !classHasFontWeight(className) && "font-semibold",
        "font-title text",
      )}
      {...rest}
    >
      {children}
    </p>
  )
}

export default Title;